import { render, staticRenderFns } from "./InteractiveGiftCard.vue?vue&type=template&id=3af9c146&scoped=true"
import script from "./InteractiveGiftCard.vue?vue&type=script&lang=ts"
export * from "./InteractiveGiftCard.vue?vue&type=script&lang=ts"
import style0 from "./InteractiveGiftCard.vue?vue&type=style&index=0&id=3af9c146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af9c146",
  null
  
)

export default component.exports